import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpErrorResponse,
  HttpClientModule
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError, tap, map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { NewRequest } from "../models/newRequest.model";

@Injectable({
  providedIn: "root"
})
export class CommissionService {
  private baseurl: string;
  private request: NewRequest;

  constructor(private http: HttpClient) {
    this.baseurl = environment.apiConfig.apiUrl;
  }

  getAgentsByAgencyID(agencyID): Observable<any> {
    return this.http.get(
      this.baseurl + "/commissions/getAgentsByAgencyID/" + agencyID
    );
  }

  getProgramCodes(): Observable<any> {
    return this.http.get(this.baseurl + "/commissions/getProgramCodes/");
  }

  getTerms(): Observable<any> {
    return this.http.get(this.baseurl + "/commissions/getTerms/");
  }

  getProgramCampuses(): Observable<any> {
    return this.http.get(this.baseurl + "/commissions/getProgramCampuses/");
  }

  getCommissionNewRequest(id: string, term:string): Observable<any> {
    let path = this.baseurl + "/commissions/getCommissionsNewRequest/" + id + "/" + term;

    return this.http.get(path);
  }

  getCommissionSubmittedRequest(
    requestTypeID: string,
    id: string,
    agency:string,
    term?:string
  ): Observable<any> {
    let path =
      this.baseurl + "/commissions/getCommissionSubmittedRequest/" + id+ "/" + agency;

    if (requestTypeID != "7" && requestTypeID != "8") {
      path = this.baseurl + "/commissions/getCommissionMissingRequest/" + id+ "/" + agency;
    }

    if (term) {
      path += "?term=" + encodeURIComponent(term);
    }

    return this.http.get(path);
  }

  getCommissionsNewRequests(agencyID): Observable<any> {
    return this.http.get(
      this.baseurl + "/commissions/getCommissionsNewRequests/" + agencyID
    );
  }

  getCommissionsSubmittedRequests(agencyID): Observable<any> {
    return this.http.get(
      this.baseurl + "/commissions/getCommissionsSubmittedRequests/" + agencyID
    );
  }

  updateSubmittedRequests(parameters: any, agentID: Number): Observable<any> {
    return this.http.post(
      this.baseurl + "/commissions/updateSubmittedRequests/",
      {parameters:parameters, agentID: agentID}
    );
  }

  updateRequest(requestID: number, agentID: number, term:string, formValue: any) {
    formValue.agentID = agentID;
    formValue.term = term;

    try {
      return this.http.post(
        this.baseurl + `/commissions/updateRequest/${requestID}`,
        {...formValue,
          parameters:[requestID]
        }
      );
    } catch (err) {
      console.log(err);
      return throwError(err);
    }
  }

  updateNotFoundRequest(createdByID: string, formValue: any) {
    try {
      formValue.createdByID = createdByID;
      return this.http.post(
        this.baseurl + `/commissions/updateNotFoundRequest`,
        formValue
      );
    } catch (err) {
      console.log(err);
      return throwError(err);
    }
  }

  getMissingFromAppIDandCode(formValue: any): Observable<any> {
    try {
      return this.http.post(
        this.baseurl + `/commissions/getMissingFromAppIDandProgram`,
        formValue
      );
    } catch (err) {
      console.log(err);
      return throwError(err);
    }
  }
}
